import { render, staticRenderFns } from "./SmartExercises.vue?vue&type=template&id=71ba6172&"
import script from "./SmartExercises.vue?vue&type=script&lang=js&"
export * from "./SmartExercises.vue?vue&type=script&lang=js&"
import style0 from "./SmartExercises.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VOverlay,VProgressCircular})
